import { render, staticRenderFns } from "./ConfigurationItemRow.vue?vue&type=template&id=cefd7628&"
import script from "./ConfigurationItemRow.vue?vue&type=script&lang=ts&"
export * from "./ConfigurationItemRow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports